import { TableCell, TableRow, TypographyProps } from "@mui/material";

import {
  EmissionStyle,
  DurationStyle,
  CostStyle,
  NameCellStyle,
  TableRowStyle,
} from "@/features/outcomeOverview/styles/styles";
import { OverviewTableModel } from "@/features/outcomeOverview/types/types";
import { RNumberLabel } from "@/shared/components/inputs";
import { getTextColor } from "@/shared/utils";

type TableRowProps = {
  row: OverviewTableModel;
};

export default function OverviewTableRow({ row }: TableRowProps) {
  const { id, backgroundColor, name, cost, duration, emissions } = row;
  const textColor = getTextColor(backgroundColor);

  const typographyProps: TypographyProps = {
    variant: "h5",
    fontWeight: 500,
    color: textColor,
  };
  return (
    <TableRow key={id} sx={TableRowStyle(backgroundColor)}>
      <TableCell sx={NameCellStyle(textColor)}>{name}</TableCell>
      <TableCell sx={CostStyle}>
        <RNumberLabel
          value={cost}
          category="currency"
          decimalScale={2}
          typographyProps={typographyProps}
        />
      </TableCell>
      <TableCell sx={DurationStyle}>
        <RNumberLabel
          value={duration}
          category="duration"
          decimalScale={2}
          typographyProps={typographyProps}
        />
      </TableCell>
      <TableCell sx={EmissionStyle}>
        <RNumberLabel
          value={emissions}
          category="emissions"
          decimalScale={2}
          typographyProps={typographyProps}
        />
      </TableCell>
    </TableRow>
  );
}
